import { EnvService } from './env.service';

export const EnvServiceFactory = () => {  
  // Creamos el ambiente
  const env = new EnvService();
  // Leemos las variables de ambiente desde la ventana del navegador
  const browserWindow = window || {};
  const browserWindowEnv = browserWindow['__env'] || {};
  
  // Asignamos las variables de ambiente desde el navegador hacia env
  // En la implementacion actual, las propiedades de env.js sobreescriben los
  // valores por default en el EnvService
  // Si lo necesitas, aquí se puede realizar una fusión profunda para fusionar propiedades en lugar de sobrescribirlas

  for (const key in browserWindowEnv) {
    if (browserWindowEnv.hasOwnProperty(key)) {
      env[key] = window['__env'][key];
    }
  }

  return env;
};

export const EnvServiceProvider = {  
  provide: EnvService, //Importamos este servicio definido con anterioridad
  useFactory: EnvServiceFactory, //Exportamos el factory que crea la instancia de EnvService y copia los valores del objeto `window.__env` en la instancia de EnvService
  deps: [],
};
